import { configureOkendo } from '@okendo/okendo-widgets-vue'
import Flickity from 'flickity'

// style/vendor/flickity seems to provide the needed styles, but i'll leave this
// here for reference.
//import 'flickity/dist/flickity.min.css'

/**
 * @link https://www.npmjs.com/package/@okendo/okendo-widgets-vue
 */
export default () => {
  const subscriberId = process.env.OKENDO_SUBSCRIBER_ID
  // console.log('okendo', subscriberId)
  if (subscriberId) {
    // this global is required to render review images
    window.Flickity = Flickity
    configureOkendo({
      subscriberId,
      widgetSettings: {
        enableFilters: false,
        defaultReviewsSortOrder: 'rating desc'
      }
    })
  }
}
